import { Auth } from "aws-amplify";

export const getUser = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser(); // Await the promise
    return user.username; // Return the username
  } catch (err) {
    console.log("Error in getUser: ", err);
    return null; // Handle the case where user is not authenticated
  }
};

export const condenseSlideAPI = async (formData) => {
  const username = await getUser();
  formData.append("username", username);

  for(var pair of formData.entries()) {
    console.log(pair[0]+ ', ' + pair[1]); 
  }
  try {
    const response = await fetch(
      `${process.env.REACT_APP_FASTAPI_URL}/condense_slide`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    throw new Error(`Error fetching file: ${err.message}`);
  }
};

export const splitSlideAPI = async (formData) => {
  const username = await getUser();
  formData.append("username", username);
  try {
    const response = await fetch(
      `${process.env.REACT_APP_FASTAPI_URL}/split_slide`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    throw new Error(`Error fetching file: ${err.message}`);
  }
};

export const checkSlidesForSpeakerNotes = async (slideUrl) => {
  const formData = new FormData();
  formData.append("s3_url", slideUrl);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_FASTAPI_URL}/validate_slide_deck_speaker_notes`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    throw new Error(`Error validating slide deck: ${err.message}`);
  }
};

